<div class="renewal-report-container">
    <div class="boxed-section">
        <h3 class="report-form-heading" *ngIf="!isCreateMode">{{ activeReport.name | decodeHtml }}</h3>
        <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="renewal-report-form">

            <div class="flex-form-field">
                <mat-label>Report Type</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="reportType" required>
                        <ng-container *ngFor="let reportType of reportTypes">
                            <mat-option [value]="reportType">{{reportType | titlecase}}</mat-option>
                        </ng-container>
                    </mat-select>
                    <mat-error *ngIf="reportForm.get('reportType').invalid && reportForm.get('reportType').touched">
                        Report Type is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="flex-form-field">
                <mat-label>Portfolio</mat-label>
                <div class="group-mat-trigger-container">
                    <button #portfolioMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="portfolioMenu" class="group-mat-trigger" type="button" [ngClass]="{'invalid-group-trigger': isPorfolioControlInvalid()}">
                        <span class="selected-group">{{ this.reportForm.get('portfolio').value &&
                            (selectedPortfolioGroup.name | decodeHtml) }}</span>
                        <span class="down-arrow-icon"></span>
                    </button>
                    <mat-error *ngIf="isPorfolioControlInvalid()">
                        Portfolio is required
                    </mat-error>
                </div>

                <mat-menu #portfolioMenu="matMenu" class="renewal-report-mat-tree-container">
                    <ng-container *ngIf="portfolioGroupDataSource.data[0]?.children?.length > 0">
                        <mat-tree [dataSource]="portfolioGroupDataSource" [treeControl]="portfolioGroupTreeControl"
                            class="sub-menu-options-child renewal-report-mat-tree">
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle
                                class="sub-menu-form-options-tree" style="flex-direction: column !important;">
                                <ng-container>
                                    <ul style="padding: 0px; margin: 0px; width: fit-content">
                                        <li style="width: 100% !important; font-size: 12px; cursor: pointer;"
                                            [ngClass]="getNodeClass(node)">
                                            <div (click)="selectePortfolioGroup(node)"
                                            [matTooltip]="node.name | decodeHtml"
                                            matTooltipPosition="right">
                                                {{ node.name | decodeHtml }}
                                            </div>
                                        </li>
                                    </ul>
                                </ng-container>
                            </mat-tree-node>
                            <mat-nested-tree-node *matTreeNodeDef="let node; when: portfolioGroupTreeStructure.hasChild"
                                class="heatmap-sub-menu sub-menu-options-parent external-sub-menu">
                                <ul style="padding: 0px; margin: 0px">
                                    <li class="global-filter">
                                        <hr class="menu-line-separator" />
                                        <div class="mat-tree-node"
                                            style="display: flex !important; flex-direction: row !important; justify-content: space-between !important; width: 100% !important; cursor:pointer;"
                                            (click)="selectePortfolioGroup(node)">

                                            <span [ngClass]="getParentNodeClass(node)"
                                            [matTooltip]="node.name | decodeHtml"
                                            matTooltipPosition="right">{{ node.name | decodeHtml }}</span>
                                            <button mat-icon-button matTreeNodeToggle
                                                [attr.aria-label]="'toggle ' + node.name">
                                                <mat-icon class="mat-icon-rtl-mirror">
                                                    {{portfolioGroupTreeControl.isExpanded(node) ? 'expand_more' :
                                                    'chevron_right'}}
                                                </mat-icon>
                                            </button>
                                        </div>
                                        <ul [class.tree-invisible]="!portfolioGroupTreeControl.isExpanded(node)">
                                            <ng-container matTreeNodeOutlet></ng-container>
                                        </ul>
                                    </li>
                                </ul>
                            </mat-nested-tree-node>
                        </mat-tree>
                    </ng-container>
                </mat-menu>
                <!-- <mat-form-field appearance="outline">
                    <mat-select formControlName="portfolio">
                        <ng-container *ngFor="let group of eligibleGroups">
                            <mat-option [value]="group.id"
                                *ngIf="reportForm.get('compareWith').value !== group.id">{{group.name}}</mat-option>
                        </ng-container>
                    </mat-select>
                    <mat-error *ngIf="reportForm.get('portfolio').invalid && reportForm.get('portfolio').touched">
                        Portfolio is required
                    </mat-error>
                </mat-form-field> -->
            </div>
            <div class="flex-form-field">
                <mat-label>Compare With</mat-label>
                <div class="group-mat-trigger-container">
                    <button #compareWithMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="compareWithMenu" class="group-mat-trigger" type="button" [ngClass]="{'invalid-group-trigger': isCompareWithControlInvalid()}">
                        <span class="selected-group">{{ this.reportForm.get('compareWith').value &&
                            (selectedCompareWithGroup.name | decodeHtml) }}</span>
                        <span class="down-arrow-icon"></span>
                    </button>
                    <mat-error *ngIf="isCompareWithControlInvalid()">
                        Compare With is required
                    </mat-error>
                </div>

                <mat-menu #compareWithMenu="matMenu" class="renewal-report-mat-tree-container">
                    <ng-container *ngIf="compareWithGroupDataSource.data[0]?.children?.length > 0">
                        <mat-tree [dataSource]="compareWithGroupDataSource" [treeControl]="compareWithGroupTreeControl"
                            class="sub-menu-options-child renewal-report-mat-tree">
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle
                                class="sub-menu-form-options-tree" style="flex-direction: column !important;">
                                <ng-container>
                                    <ul style="padding: 0px; margin: 0px; width: fit-content">
                                        <li style="width: 100% !important; font-size: 12px; cursor: pointer;"
                                            [ngClass]="getNodeClass(node)">
                                            <div (click)="selectCompareWithGroup(node)"
                                            [matTooltip]="node.name | decodeHtml"
                                            matTooltipPosition="right">
                                                {{ node.name | decodeHtml }}
                                            </div>
                                        </li>
                                    </ul>
                                </ng-container>
                            </mat-tree-node>
                            <mat-nested-tree-node *matTreeNodeDef="let node; when: compareWithGroupTreeStructure.hasChild"
                                class="heatmap-sub-menu sub-menu-options-parent external-sub-menu">
                                <ul style="padding: 0px; margin: 0px">
                                    <li class="global-filter">
                                        <hr class="menu-line-separator" />
                                        <div class="mat-tree-node"
                                            style="display: flex !important; flex-direction: row !important; justify-content: space-between !important; width: 100% !important; cursor:pointer;"
                                            (click)="selectCompareWithGroup(node)">

                                            <span [ngClass]="getParentNodeClass(node)"
                                            [matTooltip]="node.name | decodeHtml"
                                            matTooltipPosition="right">{{ node.name | decodeHtml }}</span>
                                            <button mat-icon-button matTreeNodeToggle
                                                [attr.aria-label]="'toggle ' + node.name">
                                                <mat-icon class="mat-icon-rtl-mirror">
                                                    {{compareWithGroupTreeControl.isExpanded(node) ? 'expand_more' :
                                                    'chevron_right'}}
                                                </mat-icon>
                                            </button>
                                        </div>
                                        <ul [class.tree-invisible]="!compareWithGroupTreeControl.isExpanded(node)">
                                            <ng-container matTreeNodeOutlet></ng-container>
                                        </ul>
                                    </li>
                                </ul>
                            </mat-nested-tree-node>
                        </mat-tree>
                    </ng-container>
                </mat-menu>
                <!-- <mat-label>Compare With</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="compareWith">
                        <ng-container *ngFor="let group of eligibleGroups">
                            <mat-option [value]="group.id"
                                *ngIf="reportForm.get('portfolio').value !== group.id">{{group.name}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field> -->
            </div>
            <div class="flex-form-field">
                <mat-label>Reference Value</mat-label>
                <mat-form-field appearance="outline">
                    <mat-select formControlName="referenceValue">
                        <ng-container *ngFor="let internalField of internalFields">
                            <mat-option [value]="internalField.id">{{ (internalField.displayName ?? internalField.name) | decodeHtml }}</mat-option>
                        </ng-container>
                    </mat-select>
                    <mat-error
                        *ngIf="reportForm.get('referenceValue').invalid && reportForm.get('referenceValue').touched">
                        Reference Value is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="report-tabs-conatiner">
                <mat-label>Select Report Tabs</mat-label>
                <div class="report-tabs-checkbox-container">
                    <ng-container *ngFor="let key of constantReportTabKeys">
                        <mat-checkbox *ngIf="hasTabAccess(key)" [checked]="selectedReportTabs.includes(key)"
                            (change)="toggleSelection(key)"
                            [disabled]="constantReportTabs[key].isComparison && !reportForm.get('compareWith').value">
                            {{ constantReportTabs[key].value }}
                        </mat-checkbox>
                    </ng-container>
                </div>

                <mat-error *ngIf="isSubmitted && !selectedReportTabs.length">
                    Select atleast one report tab
                </mat-error>
            </div>

            <div class="excess-fields-conatiner">
                <mat-label>Define Excess Value(s)</mat-label>
                <div formArrayName="excessValues" class="excess-values-fields-conatiner">
                    <div *ngFor="let excessValueGroup of excessValues.controls; let i = index; let last = last;" [formGroupName]="i">
                        <div class="excess-field">
                            <mat-form-field appearance="outline">
                                <input matInput 
                                       type="number" 
                                       formControlName="value"
                                       [step]="excessValueGroup.get('unit')?.value === 'B' ? '0.1' : '1'"
                                       [min]="excessValueGroup.get('unit')?.value === 'B' ? '0.1' : '1'"
                                       placeholder="Enter value">
                                
                                <!-- Required field error (empty input) -->
                                <mat-error *ngIf="excessValueGroup.get('value')?.touched && (excessValueGroup.get('value')?.value === null || excessValueGroup.get('value')?.value === '' || excessValueGroup.get('value')?.value === undefined)" class="excess-value-error">
                                    {{ excessValueGroup.get('unit')?.value === 'M' ? 'Million' : 'Billion' }} value is required
                                </mat-error>
                                
                                <!-- Million validation errors -->
                                <mat-error *ngIf="excessValueGroup.get('value')?.hasError('maxMillion') && (excessValueGroup.get('value')?.touched || excessValueGroup.get('value')?.dirty)" class="excess-value-error">
                                    Maximum 3 digits allowed (no decimals).
                                </mat-error>
                                <mat-error *ngIf="excessValueGroup.get('value')?.hasError('decimal') && excessValueGroup.get('unit')?.value === 'M' && (excessValueGroup.get('value')?.touched || excessValueGroup.get('value')?.dirty)" class="excess-value-error">
                                    Maximum 3 digits allowed (no decimals).
                                </mat-error>
                                
                                <!-- Billion validation errors -->
                                <mat-error *ngIf="excessValueGroup.get('value')?.hasError('maxBillion') && (excessValueGroup.get('value')?.touched || excessValueGroup.get('value')?.dirty)" class="excess-value-error">
                                    Maximum 3 digits with 1 decimal place allowed.
                                </mat-error>
                                <mat-error *ngIf="excessValueGroup.get('value')?.hasError('maxDecimal') && (excessValueGroup.get('value')?.touched || excessValueGroup.get('value')?.dirty)" class="excess-value-error">
                                    Maximum 3 digits with 1 decimal place allowed.
                                </mat-error>
                                
                                <!-- Common validation errors -->
                                <mat-error *ngIf="excessValueGroup.get('value')?.hasError('min') && (excessValueGroup.get('value')?.touched || excessValueGroup.get('value')?.dirty)" class="excess-value-error">
                                    Value must be at least {{ excessValueGroup.get('unit')?.value === 'M' ? '1' : '0.1' }}
                                </mat-error>
                            </mat-form-field>
                            
                            <label for="{{ i }}">{{ excessValueGroup.get('unit')?.value }}</label>
                            
                            <!-- Show '+' icon on last entry of each unit type -->
                            <button class="excess-field-action-button"
                                type="button"
                                *ngIf="i === getLastIndexOfUnit('M') || i === getLastIndexOfUnit('B')"
                                [disabled]="excessValues.length >= excessValuesLimit || !canAddFromIndex(i)"
                                (click)="addExcessValue(undefined, i)">
                                <mat-icon>add</mat-icon>
                            </button>

                            <!-- Show 'close' icon on entries with value that are not the last entry of their unit type -->
                            <button class="excess-field-action-button" *ngIf="i !== getLastIndexOfUnit('M') && i !== getLastIndexOfUnit('B') && excessValueGroup.get('value')?.value !== null && excessValueGroup.get('value')?.value !== '' && excessValueGroup.get('value')?.value !== undefined"
                                type="button" (click)="removeExcessValue(i)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report-action-buttons">
                <button type="submit" mat-flat-button type="submit" color="accent" class="map-button">
                    Save
                </button>
                <button mat-flat-button type="button" color="accent" class="map-button" (click)="onSubmit(false)">
                    Save As
                </button>
                <button mat-flat-button type="button" color="primary" class="map-button"
                    [disabled]="isCreateMode || !activeReport?.isDeletable" (click)="deleteRenewalReport(activeReport)">
                    Delete
                </button>
                <button mat-flat-button type="button" color="primary" class="map-button" (click)="closeReportPanel()">
                    Cancel
                </button>
                <button mat-flat-button type="button" color="primary" class="map-button" [disabled]="isCreateMode"
                    (click)="downloadRenewalReport(activeReport)">
                    Download
                </button>
            </div>
        </form>
    </div>
</div>

<app-workspace-item-dialog #workspaceItemDialog [accountId]="dataset?.accountID" [datasetId]="dataset?.id"
    (itemSubmitted)="setActiveReport($event)"></app-workspace-item-dialog>